<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm8>
        <h1>{{ $t('a') }}</h1>
        <v-layout wrap mt-2 mb-2 justify-center>
          <v-flex xs12 text-center>
            <img :src="images.top" height="250px" class="mb-4"/>
          </v-flex>
          <v-flex xs8 text-center>
            <v-card class="px-12 pt-3 pb-6">
              <div v-if="isPending">
                <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
              </div>
              <div v-else-if="success">
                <div><v-icon color="secondary">check</v-icon></div>
                <div>{{ $t('b') }} {{user.data.email}}</div>
                <div class="mt-2"><b>{{ $t('c') }}</b></div>
              </div>
              <div v-if="errorMessage">
                <div class="error--text mt-2">{{ $t('d') }}</div>
                <div v-if="errorMessage === 'TOO_MANY_ATTEMPTS_TRY_LATER'"><small>{{ $t('d2') }}</small></div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="showSendAgain">
      <v-flex xs4 text-center>
        <v-card v-if="success || errorMessage" class="mt-12 py-4 px-2 mb-12">
          <small>
            <div>
              <div>{{ $t('e') }}</div>
              <v-btn @click="sendEmail" small class="mt-2" outlined>{{ $t('f') }}</v-btn>
            </div>
            <div class="mt-3">{{ $t('g') }} <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a> {{ $t('h') }}</div>
          </small>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import vuei18n from '@/i18n'
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isPending: false,
    success: false,
    errorMessage: null,
    showSendAgain: false,
    images: {
      top: require('@/assets/app/images/new_message_flatline.svg'),
    },
    intervalOfRegularlyUpdateUserIsEmailVerified: null,
    numberOfTimesEmailWasSent: 0
  }),
  mounted() {
    this.sendEmail()
  },
  beforeDestroy() {
    if (this.intervalOfRegularlyUpdateUserIsEmailVerified) {
      clearInterval(this.intervalOfRegularlyUpdateUserIsEmailVerified)
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
    isUserEmailVerified() {
      return this.user.data.isEmailVerified
    }
  },
  methods: {
    sendEmail() {
      const _this = this
      this.isPending = true
      this.success = false
      this.errorMessage = null
      this.showSendAgain = false
      
      // console.log('this.numberOfTimesEmailWasSent', this.numberOfTimesEmailWasSent); // eslint-disable-line
      if (this.numberOfTimesEmailWasSent === 0 || this.numberOfTimesEmailWasSent >= 4) {
        // The first time, send email via the oldfashion firebase way.
        const user = this.$auth.currentUser;
        const actionCodeSettings = {
          url: window.location.origin + '/onboarding/verify-email-success'
        }
        user.sendEmailVerification(actionCodeSettings)
        .then(function() {
          _this.success = true
          _this.isPending = false
        }).catch(function(error) {
          _this.isPending = false
          console.log('error', error); // eslint-disable-line
          if (error.code === 'auth/too-many-requests') {
            _this.errorMessage = 'TOO_MANY_ATTEMPTS_TRY_LATER'
          } else {
            _this.errorMessage = error.message
          }
        });
      } else {
        // 2nd time, and 3rd and 4th, send email from back-end with sendgrid.
        this.$functions.httpsCallable('sendEmailForEmailAddressVerification')({
          locale: vuei18n.locale === 'en' ? 'en' : 'fr',
          numberOfTimesEmailWasSent: this.numberOfTimesEmailWasSent
        })
        .then(function(response) {
          if (response.data.success) {
            _this.success = true
            _this.isPending = false
          } else {
            _this.isPending = false
            if (response.data.errorType === 'TOO_MANY_ATTEMPTS_TRY_LATER') {
              _this.errorMessage = 'TOO_MANY_ATTEMPTS_TRY_LATER'
            } else {
              _this.errorMessage = true
            }
          }
        }).catch(function() {
          _this.isPending = false
          _this.errorMessage = true
        });
      }

      _this.numberOfTimesEmailWasSent += 1
      if (!this.intervalOfRegularlyUpdateUserIsEmailVerified) {
        this.regularlyUpdateUserIsEmailVerified()
      }
      
      // setTimeout(function() {
      _this.showSendAgain = true
      // }, 10000)
    },
    async regularlyUpdateUserIsEmailVerified() {
      this.intervalOfRegularlyUpdateUserIsEmailVerified = setInterval(async () => {
        await this.$functions.httpsCallable('updateUserIsEmailVerified')({})
      }, 8000)
    }
  },
  watch: {
    isUserEmailVerified: {
      handler() {
        if (this.isUserEmailVerified) {
          this.$router.push('/onboarding/verify-email-success')
        }
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Vérification de votre adresse email",
    "b": "Nous vous avons envoyé un email à",
    "c": "Cliquez sur le lien du mail pour vérifier votre adresse mail et accéder à nos services.",
    "d": "Erreur lors de l'envoi de l'email.",
    "d2": "Trop de tentatives consécutives d'envoi d'email. Veuillez patienter une petite minute avant d'essayer à nouveau.",
    "e": "Vous n'avez pas reçu notre email ?",
    "f": "Envoyer à nouveau",
    "g": "Si vous ne le recevez toujours pas, vérifiez dans vos spams ou contactez",
    "h": "pour valider votre compte."
  },
  "en": {
    "a": "Verification of your email address",
    "b": "We sent you an email at",
    "c": "Click on the email link to verify your email address and finish the creation of your account.",
    "d": "Error while sending the email.",
    "d2": "Too many consecutive attempts. Please wait a minute before trying again.",
    "e": "You didn't receive our email ?",
    "f": "Send again",
    "g": "If you still haven't received the email, check your spam folder or contact",
    "h": "to validate your account."
  }
}
</i18n>